import React from "react";
import * as Helper from "../../utils/Helper";
import Constants from "../../config/Constants";
import Sentence from "./Sentence";
import AudioPlayer from "./AudioPlayer";
class ContentFieldRender extends React.Component {
    render() {
        const { richArticleChildren, fontSize, lineHeight, imgw } = this.props;
        const contentFieldPayloads = Helper.extractFieldsFromContentFieldPayloads(richArticleChildren);
        // Helper.extractFieldsFromContentFieldPayloads()
        return (
            <div style={{ display: "flex", flexDirection: "column", overflowY: "auto" }}>
                {contentFieldPayloads &&
                    contentFieldPayloads.map((fieldPayload, index) => {
                        const type = Constants.FIELD_TYPE[fieldPayload.fieldName.toUpperCase()];
                        let content = <></>;
                        switch (type) {
                            case Constants.FIELD_TYPE.CHARSFIELD:
                                let article = JSON.parse(richArticleChildren[index].fieldPayload);
                                content = (
                                    <div style={{ fontSize: `${fontSize}px`, lineHeight: `${lineHeight}px` }}>
                                        {article.sentences &&
                                            article.sentences.map((sentence, sentenceIndex) => {
                                                return (
                                                    // <div>{sentence.chars.join("").replace(/,/g, "")}</div>
                                                    <Sentence
                                                        key={sentenceIndex}
                                                        pinyinVisible={false}
                                                        style={{
                                                            marginTop: `${fontSize / 3}px`,
                                                            marginRight: `${fontSize / 1.5}px`,
                                                            marginBottom: `${fontSize / 3}px`,
                                                            paddingLeft: `${fontSize / 3}px`,
                                                            paddingRight: `${fontSize / 3}px`,
                                                            fontSize: `${fontSize}px`,
                                                            lineHeight: `${lineHeight}px`,
                                                            borderRadius: "6px",
                                                            backgroundColor: "rgba(240,240,240)",
                                                            flexWrap: "wrap",
                                                            float: "left",
                                                        }}
                                                        data={sentence}
                                                    />
                                                );
                                            })}
                                    </div>
                                );
                                break;
                            case Constants.FIELD_TYPE.IMAGEFIELD:
                                content = (
                                    <img
                                        src={Helper.convertToFileServerPath(fieldPayload.imagePath.value)}
                                        alt={fieldPayload.imagePath.value}
                                        style={{ width: `${imgw}px`, height: `${imgw}px`, marginTop: "5px" }}
                                    />
                                );
                                break;
                            case Constants.FIELD_TYPE.AUDIOFIELD:
                                content = (
                                    // TODO: 将这里改成图标的形式
                                    // <FontAwesomeIcon icon={faPlayCircle} style={{ height: "24px", width: "24px" }} />
                                    // <audio controls>
                                    //     <source src={Helper.convertToFileServerPath(fieldPayload.audioPath.value)} type="audio/mp3" />
                                    // </audio>
                                    <AudioPlayer src={fieldPayload.audioPath.value} />
                                );
                                break;
                            default:
                                break;
                        }
                        return (
                            <div key={index} style={{ marginTop: `${fontSize / 5}px`, fontSize: `${fontSize}px`, lineHeight: `${lineHeight}px` }}>
                                {content}
                            </div>
                        );
                    })}
            </div>
        );
    }
}
export default ContentFieldRender;
